/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import OktaSignIn from '@okta/okta-signin-widget';
import { environment } from 'src/environments/environment';
import { OktaService, createOieWidget } from 'sustainment-component';

@Injectable()
export class PortalOktaService extends OktaService {
  public widget: OktaSignIn;

  public constructor() {
    super();
    this.initClient();
  }

  protected initClient(): void {
    this.widget = createOieWidget({
      baseUrl: environment.okta.baseUrl,
      clientId: environment.okta.clientId,
      googleId: environment.okta.googleId,
      logoText: 'Sustainment Portal'
    });
  }
}
